import { Icon, MenuButton, PathButton } from "shared/react";
import { getGroupPath } from "shared/schema";
import { useItem } from "../util/db.js";
import { GroupMenu } from "./GroupMenu.js";

export function GroupNavigation({ gid }: { gid: string }): React.ReactElement | null {
	const group = useItem("group", gid).data;
	const path = getGroupPath(group);
	return (
		<nav className="space-none pad-none flex-row flex-stretch width-wide">
			<PathButton path={`${path}/messages`} title="Messages">
				<Icon icon="chat" />
			</PathButton>
			<PathButton path={`${path}/about`} title="About">
				<Icon icon="info" />
			</PathButton>
			<PathButton path={`${path}/assigned`} title="Assigned challenges">
				<Icon icon="challenge" />
			</PathButton>
			<PathButton path={`${path}/leaderboards`} title="Joined leaderboards">
				<Icon icon="leaderboard" />
			</PathButton>
			<MenuButton menu={<GroupMenu gid={gid} />} />
		</nav>
	);
}
